import styled from "@emotion/styled";
import type { FC } from "react";
import { SmartCardSection } from "@/components/heads-up/cards/common/layout";
import { CollapsibleSectionHeader } from "@/components/heads-up/cards/common/collapsible-section-header";
import { HeadsUpLabsBadge } from "@/components/heads-up/cards/common/heads-up-labs-badge";
import { LivePulseIndicator } from "@/components/heads-up/cards/common/live-pulse-indicator";
import { HeadsUpLiveExplainer } from "@/components/heads-up/cards/common/heads-up-live-explainer";
import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

interface Props {
  isLiveActive?: boolean;
}

export const LiveEmptyStateCard: FC<Props> = ({ isLiveActive = false }) => {
  const headerExtra = (
    <HeaderExtra>
      <HeadsUpLabsBadge />
      {isLiveActive ? <LivePulseIndicator /> : null}
    </HeaderExtra>
  );

  return (
    <SmartCardSection>
      <CollapsibleSectionHeader
        title="Live"
        titleAccessory={
          <HeadsUpLiveExplainer
            analytics={{
              source: "empty_state",
              smartCardId: null,
              isLiveActive,
            }}
          />
        }
        headerExtra={headerExtra}
      >
        <LiveEmptyStateBody>
          <MDSText variant={MDSTextVariant.ParagraphS} color={MDSTextColor.Tertiary}>
            Context relevant to what&apos;s being said in the meeting appears here
          </MDSText>
        </LiveEmptyStateBody>
      </CollapsibleSectionHeader>
    </SmartCardSection>
  );
};

const HeaderExtra = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  margin-left: auto;
`;

const LiveEmptyStateBody = styled.div`
  padding-left: ${({ theme }) => theme.spacing["7"]};
  padding-right: ${({ theme }) => theme.spacing["2"]};
  padding-bottom: ${({ theme }) => theme.spacing["3"]};
`;
